<template>
  <div>
    <header class="search-header">
      <span class="input-wrap">
        <input
          class="input"
          v-model="input"
          :placeholder="placeholder"
          @focus="onFocus"
          @keyup.enter="goSearch"
        />
        <img v-if="input!=''" class="clear" src="@/assets/images/close@2x.png" @click="input=''" />
      </span>
      <span class="cancel" @click="goBack" v-if="input == ''">取消</span>
      <span @click="goSearch" v-if="input != ''" style="color: #000">搜索</span>
    </header>
    <SearchHistory ref="history" :type="type" :value="input" @change="onChange"></SearchHistory>
  </div>
</template>
<script>
import SearchHistory from "@/components/SearchHistory";
export default {
  name: "SearchHeader",
  components: { SearchHistory },
  props: {
    type: {
      type: String,
      default: "course"
    },
    placeholder: {
      type: String,
      default: "请输入内容"
    },
    value: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      input: ""
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$store.commit("SEARCH_INP", "");
    },
    goSearch() {
      this.$emit("search", this.input);
      this.$refs.history.add(this.input);
    },
    onFocus() {
      this.$emit("focus");
    },
    onChange(item) {
      this.input = item;
      this.$emit("search", item);
    }
  },
  watch: {
    input(newVal) {
      this.$emit("change", newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-header {
  @extend %flex-center;
  height: 94px;
  border-bottom: 1px solid rgba(234, 234, 234, 1);
  background: #fff;
  span {
    &:nth-child(1) {
      flex: 6;
      display: flex;
      align-items: center;
      margin-left: 20px;
      input {
        height: 60px;
        padding-left: 56px;
        border: none;
        background: #e4e7ed;
        border-radius: 30px;
        font-size: 30px;
        width: 100%;
      }
    }
    &:nth-child(2) {
      margin-left: 20px;
      margin-right: 16px;
      color: #595959;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 44px;
    }
  }
  .input-wrap {
    position: relative;
  }
  .clear {
    width: 26px;
    height: 26px;
    position: absolute;
    right: 20px;
  }
}
</style>